import { render } from "./AirportStatisticView.vue?vue&type=template&id=f372b352"
import script from "./AirportStatisticView.vue?vue&type=script&lang=js"
export * from "./AirportStatisticView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__